import { normalizeNumber, numberEquals } from "./filterUtils";

export function emptyTyreFilters() {
  return {
    tootja: "",
    mudel: "",
    mõõt: "",
    aspectRatio: "",
    diameeter: "",
    lisi: "",
    suverehv: false,
    talverehv: false,
    naastrehv: false,
    offroad: false,
    ringrada: false,
    taastatud: false,
  };
}

export function buildTyreQuery(filters) {
  const params = new URLSearchParams();

  if (filters.tootja) {
    params.set("BrandName", filters.tootja);
  }

  if (filters.mudel) {
    params.set("PatternModelText", filters.mudel);
  }

  const dimensionParams = parseDimensions(filters);
  Object.entries(dimensionParams).forEach(([key, value]) => {
    if (value) params.set(key, value);
  });

  const loadSpeedParams = parseLoadSpeedIndex(filters.lisi);
  Object.entries(loadSpeedParams).forEach(([key, value]) => {
    if (value) params.set(key, value);
  });

  return params.toString();
}

export function createTyreMatcher(filters) {
  const loadSpeedFilter = parseLoadSpeedIndex(filters.lisi);

  return (article) => {
    if (!matchesBrand(article, filters)) return false;
    if (!matchesModel(article, filters)) return false;
    if (!matchesDimensions(article, filters)) return false;
    if (!matchesLoadSpeed(article, loadSpeedFilter)) return false;
    if (!matchesTyreType(article, filters)) return false;
    if (!matchesCondition(article, filters)) return false;
    return true;
  };
}

function parseDimensions(filters) {
  const result = {};
  const widthValue = normalizeNumber(filters.mõõt);
  if (widthValue !== null) {
    result.Width = widthValue;
  }

  const aspectValue = normalizeNumber(filters.aspectRatio);
  if (aspectValue !== null) {
    result.AspectRatio = aspectValue;
  }

  const diameterValue = normalizeNumber(filters.diameeter);
  if (diameterValue !== null) {
    result.Diameter = diameterValue;
  }

  return result;
}

function parseLoadSpeedIndex(lisi) {
  if (!lisi) return {};
  const cleaned = lisi.toUpperCase().replace(/\s+/g, "");
  const slashCleaned = cleaned.replace(/\//g, "");
  const match = slashCleaned.match(/^(\d{2,3})([A-Z]{1,2})$/);
  if (match) {
    return { LoadIndex: match[1], SpeedIndex: match[2] };
  }
  return {};
}

function matchesBrand(article, filters) {
  if (!filters.tootja) return true;
  return article?.BrandName === filters.tootja;
}

function matchesModel(article, filters) {
  if (!filters.mudel) return true;
  const pattern = article?.PatternModelText || "";
  return pattern.toLowerCase().includes(filters.mudel.toLowerCase());
}

function matchesDimensions(article, filters) {
  const widthValue = normalizeNumber(filters.mõõt);
  if (widthValue !== null && !numberEquals(widthValue, article?.Width)) {
    return false;
  }

  const aspectValue = normalizeNumber(filters.aspectRatio);
  if (
    aspectValue !== null &&
    !numberEquals(aspectValue, article?.AspectRatio)
  ) {
    return false;
  }

  const diameterValue = normalizeNumber(filters.diameeter);
  if (
    diameterValue !== null &&
    !numberEquals(diameterValue, article?.Diameter)
  ) {
    return false;
  }

  return true;
}

function matchesLoadSpeed(article, loadSpeedFilter) {
  if (!loadSpeedFilter) return true;
  const { LoadIndex, SpeedIndex } = loadSpeedFilter;
  if (LoadIndex && String(article?.LoadIndex || "").trim() !== LoadIndex) {
    return false;
  }
  if (
    SpeedIndex &&
    String(article?.SpeedIndex || "")
      .trim()
      .toUpperCase() !== SpeedIndex
  ) {
    return false;
  }
  return true;
}

function matchesTyreType(article, filters) {
  const checks = [];
  const name = (article?.MainGroupName || "").toLowerCase();
  if (filters.suverehv)
    checks.push(
      () =>
        name.includes("summer") ||
        name.includes("all season") ||
        name.includes("inch")
    );
  if (filters.talverehv) checks.push(() => name.includes("winter"));
  if (filters.naastrehv) checks.push(() => name.includes("with stud"));
  if (filters.offroad)
    checks.push(
      () =>
        name.includes("tractor") ||
        name.includes("industry") ||
        name.includes("em /") ||
        name.includes("agro") ||
        name.includes("atv")
    );
  if (filters.ringrada)
    checks.push(() => name.includes("other") || name.includes("tpms"));
  if (filters.taastatud) checks.push(() => name.includes("retread"));

  if (!checks.length) return true;
  return checks.some((fn) => fn());
}

function matchesCondition(article, filters) {
  const name = (article?.MainGroupName || "").toLowerCase();
  const isRetreaded = name.includes("retread");

  if (filters.taastatud && !isRetreaded) {
    return false;
  }

  return true;
}
